import { useState, useEffect } from 'react'
import { Table, Card, Tag, DatePicker, Select, Button, Space, message } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import axios from 'axios'

const { RangePicker } = DatePicker

const Attendance = () => {
  const [records, setRecords] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 })
  const [filters, setFilters] = useState<Record<string, any>>({})

  const typeMap: Record<number, { label: string; color: string }> = {
    1: { label: '上班打卡', color: 'green' },
    2: { label: '下班打卡', color: 'blue' },
    3: { label: '外勤签到', color: 'orange' },
  }

  const loadRecords = async (page = 1) => {
    setLoading(true)
    try {
      const params: any = { page, pageSize: pagination.pageSize, ...filters }
      const res = await axios.get('/api/attendance/records', { params })
      if (res.data.code === 0) {
        setRecords(res.data.data.list)
        setPagination(prev => ({ ...prev, current: page, total: res.data.data.total }))
      }
    } catch (err) {
      message.error('加载考勤记录失败')
    }
    setLoading(false)
  }

  useEffect(() => { loadRecords() }, [])

  const columns = [
    {
      title: '员工',
      dataIndex: ['user', 'username'],
      key: 'username',
      render: (text: string, record: any) => text || record.user?.phone || '-',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      render: (type: number) => {
        const t = typeMap[type] || { label: '未知', color: 'default' }
        return <Tag color={t.color}>{t.label}</Tag>
      },
    },
    {
      title: '上班时间',
      dataIndex: 'clock_in',
      key: 'clock_in',
      render: (v: string) => v ? new Date(v).toLocaleString('zh-CN') : '-',
    },
    {
      title: '下班时间',
      dataIndex: 'clock_out',
      key: 'clock_out',
      render: (v: string) => v ? new Date(v).toLocaleString('zh-CN') : '-',
    },
    {
      title: '定位',
      key: 'location',
      render: (_: any, record: any) => record.location_name || '-',
    },
    {
      title: '范围内',
      dataIndex: 'is_in_range',
      key: 'is_in_range',
      render: (v: number) => v ? <Tag color="green">范围内</Tag> : <Tag color="red">范围外</Tag>,
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      render: (v: string) => v || '-',
    },
    {
      title: '打卡时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (v: string) => new Date(v).toLocaleString('zh-CN'),
    },
  ]

  return (
    <Card title={<><ClockCircleOutlined /> 考勤记录</>} extra={
      <Space>
        <RangePicker onChange={(dates: any) => {
          if (dates) {
            setFilters(prev => ({ ...prev, start_date: dates[0]?.format('YYYY-MM-DD'), end_date: dates[1]?.format('YYYY-MM-DD') }))
          } else {
            const { start_date, end_date, ...rest } = filters
            setFilters(rest)
          }
        }} />
        <Select placeholder="打卡类型" allowClear style={{ width: 120 }} onChange={(v: number | undefined) => {
          if (v) setFilters(prev => ({ ...prev, type: v }))
          else { const { type, ...rest } = filters; setFilters(rest) }
        }}>
          <Select.Option value={1}>上班打卡</Select.Option>
          <Select.Option value={2}>下班打卡</Select.Option>
          <Select.Option value={3}>外勤签到</Select.Option>
        </Select>
        <Button type="primary" onClick={() => loadRecords(1)}>查询</Button>
      </Space>
    }>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={records}
        loading={loading}
        pagination={{
          ...pagination,
          onChange: (page) => loadRecords(page),
          showTotal: (total) => `共 ${total} 条`,
        }}
      />
    </Card>
  )
}

export default Attendance
